import React, { useMemo } from 'react'
import { ErfResponse } from '../../../api/bridgingFinance/searchPropertyByErf'
import { SectionalTitleNameResponse } from '../../../api/bridgingFinance/searchPropertyBySectionalTitleName'
import '../SearchResultsTable.css'
import { EmptyMessage } from '../../kyc/EmptyMessage'

export interface PropertyTableProps {
  entries?: SectionalTitleNameResponse[] | null
  title: string
  onRowClick?: (row: SectionalTitleNameResponse) => void
}

export const SearchBySectionalTitleNameResultsTable: React.FC<
  PropertyTableProps
> = ({ entries, title, onRowClick }) => {
  const handleClick = (erf: SectionalTitleNameResponse) => () => {
    if (onRowClick) onRowClick(erf)
  }

  const showEmpty = useMemo(() => !entries, [entries])
  if (entries === undefined) return null

  return (
    <div className="kyc-bf-results-table-container">
      <h3 className="table-title">{title}</h3>
      <table>
        <thead>
          <tr style={{ height: '40px' }}>
            <th>Scheme Name</th>
            <th>Address</th>
            <th>Suburb</th>
            <th>Municipality Name</th>
            {/* <th>Allotment</th>
          <th>CMA ID</th> */}
          </tr>
        </thead>
        <tbody>
          {showEmpty && <EmptyMessage />}
          {entries?.map((entry, index) => (
            <tr
              key={index}
              onClick={handleClick(entry)}
              style={{ height: '30px' }}
            >
              <td>{entry.schemeName}</td>
              <td>{entry.address}</td>
              <td>{entry.suburb}</td>
              <td>{entry.mun_name || '-'}</td>
              {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
